import * as types from './mutation-type';
const mutations = {
	[types.CHANGE_IS_FROM_WITHDRAW](state, payload) {
		state.isFromWithdraw = payload;
	},
	[types.CHANGE_IS_TO_HELP](state, payload) {
		state.isToHelp = payload;
	}
};
export default mutations;
